var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"inner-page"},[_c('Header',{attrs:{"close-menu":_vm.onCloseMenu}}),_vm._t("default"),_c('main-nav-menu',{attrs:{"is-menu-active":_vm.isMenuActive},on:{"close-menu":_vm.onCloseMenu}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }